/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LinearProgressWithLabel(props: any) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress className="uploadprogresswithlabel" variant="determinate" value={Math.round(
                    (100 * props.value) / props.totalFiles)} />
            </Box>
            <Typography style={{ marginTop:8}} variant="body2" color="text.secondary">{`${Math.round(
                    (100*props.value)/props.totalFiles,
                )}%`}</Typography>
        </Box>
    );
}
